import { useState } from 'react';
import dynamic from 'next/dynamic';
import { GetServerSidePropsContext } from 'next';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import ProductNav from '@/components/ProductCommon/ProductNav';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useSupportData } from '@/utils/hooks';
import getCanEnterFlag from '@/utils/getCanEnterFlag';
import PageConPc from '@/components/productSmart/blade';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import NextImage from '@/components/NextImage';

// 两种场景可以使用lazy 或 dynamic 1.非首屏渲染的模块（包含条件渲染）2.拆包大小并且做seo优化可以使用 ssr: true
const PageConH5: any = dynamic(() => import('@/componentsH5/productSmart/blade'), { ssr: true });
const ProductSupport: any = dynamic(() => import('@/components/ProductCommon/ProductSupport'), { ssr: false });
// 产品详情页参数
const productName = 'blade-robotic-lawn-mower';
const generalKey = 'product_mh100';

const getQueryStr = (str: string) => {
    const index = str.indexOf('?');
    return str.slice(index);
};
export default function Page({ SEO }: any) {
    const { isMobile, gloproductlist, useRouter, useEffect, useLang, getSystemTime, Link } = useGlobal();
    const router = useRouter();
    const { t } = useLang('bladeroboticlawnmower');
    const [theme, setTheme] = useState('black');
    const { locale } = router;
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const supportStr = router?.query?.support || '';
    const isShowSupport = supportStr === '1'; //是否默认显示support
    const [tabName, setTabName] = useState<string>(isShowSupport ? 'Support' : 'Overview');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);
    const searchUrl = getQueryStr(router.asPath || '');
    const searchObj = new URLSearchParams(searchUrl);
    const cid = searchObj.get('cid');
    const { flag1, flag2, flag3 } = getCanEnterFlag(cid, getSystemTime()); // 提前打开4-26号
    const [crowdTab, setCrowdTab] = useState('');

    // 切换tab
    const tabState = (val: any) => {
        setTabName(val);
        const target1 = document.querySelector('.product-tab.show-tab') as HTMLDivElement;
        const target2 = document.querySelector(`.product-tab-${val}`) as HTMLDivElement;
        if (target1) target1?.classList.remove('show-tab');
        if (target2) target2?.classList.add('show-tab');
    };

    useEffect(() => {
        if (!['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'au'].includes(locale)) {
            return router.push(`/404`);
        }
    }, [locale, router]);

    useEffect(() => {
        if (isShowSupport) {
            const target2 = document.querySelector(`.detail-nav li:nth-child(3)`) as HTMLDivElement;
            target2 && target2.click();
        }
    }, [isShowSupport]);

    useEffect(() => {
        const pcCrowd = document.querySelector('.crowdFundingPC');
        const mobileCrowd = document.querySelector('.crowdFundingH5');
        const isCrowd = !!pcCrowd || !!mobileCrowd;
        const mobileCrowdOffset = isMobile ? '280%' : '150%';
        // AniContainer.create({
        //     syncFromTo: [['.product-tab .opacity-btn', { opacity: 0 }, { opacity: 1 }, 1]],
        //     triggerElement: '.product-tab',
        //     triggerHook: 1,
        //     offset: isCrowd ? mobileCrowdOffset : '50%',
        //     duration: '20%',
        // });
    }, []);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['us', 'ca', 'uk', 'eu', 'de', 'fr', 'it', 'es', 'au']} locale={locale} pathname={'blade-robotic-lawn-mower'} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real product_common_0426`} theme={theme}>
                <ProductNav
                    className="wbg"
                    title={productMsg?.name}
                    theme={theme}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={productName}
                />
                <div className={`product-tab product-tab-Overview${tabName === 'Overview' ? ' show-tab' : ''}`}>
                    <PageCon
                        productDetail={productDetail}
                        resProductCatagory={resProductCatagory}
                        supportData={supportData}
                        callBackTheme={setTheme}
                        ecoflowflag={flag1}
                        ecoflowflag2={flag2}
                        ecoflowflag3={flag3}
                        tabChange={(val: string) => {
                            setCrowdTab(val);
                        }}
                    />
                    {/* <div className={`opacity-btn ${isMobile ? 'opacity-btn__mobile' : ''}`}>
                        <div className={`checklist-btn ${isMobile ? 'checklist-btn__mobile' : ''}`}>
                            <Link className="checklist-icon" href={'/blade-robotic-lawn-mower-checklist'}>
                                <NextImage src={require('@publicLocal/blade/detail/pc/check_list.png')} />
                            </Link>
                        </div>
                    </div> */}
                </div>
                <div className={`product-tab product-tab-Specs ${crowdTab === 'specs' ? 'tabshow-' : ''}`}>
                    {tabName === 'Specs' && (
                        <>
                            <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />
                            <div className="product-specs-tips">{t('detail.product_specs_tips')}</div>
                        </>
                    )}
                    {crowdTab === 'specs' && <div className="product-specs-tips">{t('detail.product_specs_tips')}</div>}
                </div>
                <div className={`product-tab product-tab-Support${tabName === 'Support' ? ' show-tab' : ''}`}>
                    {tabName === 'Support' && <ProductSupport theme={theme} supportData={supportData} />}
                </div>
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    // us ca 下线重定向到首页 2025/06/12
    if (['us', 'ca'].includes(locale as string)) {
        return {
            redirect: {
                destination: `/${locale}`,
                permanent: true,
            },
        };
    }
    return {
        props: {},
    };
}
